import { doApi } from './apiClient';
import type {
  PPVGeneral,
  PPVSpecific,
  PPVByYear,
  PaginatedResponse,
  ApiResponse,
} from '../types';

export const apiCreatePpv = async (data: FormData): Promise<ApiResponse<PPVSpecific>> => {
  return doApi<ApiResponse<PPVSpecific>>('api/ppv/create', 'POST', data, true);
};

export const apiEditPpv = async (
  data: FormData,
  id: number
): Promise<ApiResponse<PPVSpecific>> => {
  return doApi<ApiResponse<PPVSpecific>>(`api/ppv/edit/${id}`, 'POST', data, true);
};

export const apiCreatePpvDescription = async (
  data: FormData
): Promise<ApiResponse<PPVGeneral>> => {
  return doApi<ApiResponse<PPVGeneral>>('api/ppv/create-desc', 'POST', data, true);
};

export const apiListPpvDescriptionByInputSearch = async (
  searchName: string
): Promise<PaginatedResponse<PPVSpecific>> => {
  const body = { searchName };
  return doApi<PaginatedResponse<PPVSpecific>>('api/ppv/list', 'POST', body);
};

export const apiListPpvByYear = async (): Promise<PPVByYear[]> => {
  return doApi<PPVByYear[]>('api/ppv/list/allPpvByYear', 'GET');
};

export const apiListPpvByPage = async (
  page: number | string = 0
): Promise<PaginatedResponse<PPVSpecific>> => {
  return doApi<PaginatedResponse<PPVSpecific>>(`api/ppv/list?page=${page}`, 'GET');
};

export const apiListPpvBasicInfo = async (): Promise<PPVGeneral[]> => {
  return doApi<PPVGeneral[]>('api/ppv/basiclist', 'GET');
};

export const apiGetPpv = async (id: number): Promise<PPVSpecific> => {
  return doApi<PPVSpecific>(`api/ppv/specific/basic/${id}`, 'GET');
};

// V2 APIs

export const apiListComplete = async (): Promise<PPVSpecific[]> => {
  return doApi<PPVSpecific[]>('api/ppv/v2/listcompleteall', 'GET');
};

export const apiCreatePpvGeneraleV2 = async (
  data: FormData
): Promise<ApiResponse<PPVGeneral>> => {
  return doApi<ApiResponse<PPVGeneral>>('api/ppv/v2/general/create', 'POST', data, true);
};

export const apiEditPpvGeneraleV2 = async (
  data: FormData,
  id: number
): Promise<ApiResponse<PPVGeneral>> => {
  return doApi<ApiResponse<PPVGeneral>>(`api/ppv/v2/general/edit/${id}`, 'PUT', data, true);
};

export const apiDeletePpvGeneraleV2 = async (id: number): Promise<ApiResponse<null>> => {
  return doApi<ApiResponse<null>>(`api/ppv/v2/general/delete/${id}`, 'DELETE');
};

export const apiCreatePpvSpecificV2 = async (
  data: FormData
): Promise<ApiResponse<PPVSpecific>> => {
  return doApi<ApiResponse<PPVSpecific>>('api/ppv/v2/specific/create', 'POST', data, true);
};

export const apiEditPpvSpecificV2 = async (
  data: FormData,
  id: number
): Promise<ApiResponse<PPVSpecific>> => {
  return doApi<ApiResponse<PPVSpecific>>(`api/ppv/v2/specific/edit/${id}`, 'PUT', data, true);
};

export const apiDeletePpvSpecificV2 = async (id: number): Promise<ApiResponse<null>> => {
  return doApi<ApiResponse<null>>(`api/ppv/v2/specific/delete/${id}`, 'DELETE');
};

export interface RecentPpvDescription {
  id: number;
  name: string;
  img_path: string;
  is_big_four: boolean;
}

export interface RecentPpvArena {
  id: number;
  name: string;
}

export interface RecentPpv {
  id: number;
  date: string;
  img_path: string;
  night1: string | null;
  night2: string | null;
  night3: string | null;
  ppv_description: RecentPpvDescription;
  arena: RecentPpvArena | null;
}

export const apiGetRecentPpvs = async (limit = 3): Promise<{ data: RecentPpv[] }> =>
  doApi<{ data: RecentPpv[] }>(`api/ppv/v2/recent?limit=${limit}`, 'GET');
